import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { message } from "antd";
import dayjs from "dayjs";

// export const useFetchAuditReport = (date) => {
//   return useQuery(
//     ["getFetchAuditReport"],
//     async () => {
//       try {
//         const endpoint = `/api/v1/input/list/audit/${date}`;
//         const { result } = await GET(endpoint);
//         return result;
//       } catch (error) {
//         await message.destroy();
//         message.error("Failed To Load Audit Report..");
//         throw error;
//       }
//     }
//   );
// };

export const useFetchAuditReport = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/input/list/audit`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};


export const useFetchCase3 = () => {
  return useQuery(
    ["getFetchCase3"], async () => {
      try {
        const endpoint = `/api/v1/caseSetting/case3`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Case3..");
      throw error;
    }
  });
};
